<template>
  <div
    id="leaderIntroductoryWrap"
    class="mainCard"
  >
    <div class="title">
      {{ $t('oa.introductory.title') }}
    </div>

    <el-table
      v-if="leader"
      v-loading="loading"
      :data="chemMeetings"
      style="width: 100%;"
      class="supporterList clear-table mainCard"
      :empty-text="$t('common.noData')"
    >
      <el-table-column
        :label="$t('oa.introductory.leaderDate')"
        :min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.leader_start_time
            ? `${scope.row.leader_start_time} (${scope.row.leader_timezone})` : '-' }}
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('oa.introductory.coachDate')"
        :min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.coach_start_time
            ? `${scope.row.coach_start_time} (${scope.row.coach_timezone})` : '-' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="coach"
        :label="$t('coach.coach')"
        :min-width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.coach_name }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('oa.introductory.meetingStatus')"
        :min-width="120"
      >
        <template slot-scope="scope">
          {{ $t(`meetingStatus.${scope.row.status}`) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'IntroductoryList',

  props: {
    leader: {
      type: Object,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    chemMeetings() {
      let list = [];
      if (this.leader?.chem_meeting && Array.isArray(this.leader.chem_meeting)) {
        list = this.leader.chem_meeting;
      }
      return list;
    },
  },
};
</script>

<style lang="scss" scoped>
  #leaderIntroductoryWrap {
    .title {
      width: 100%;
      font-weight: bold;
      margin-bottom: 8px;
      color: var(--themeFontColor);
    }

    .coachLink {
      color: var(--themeFontColor);
    }
  }
</style>
